export default {
  fields: {
    sales: {
      label: 'Umsatz',
    },
    gift_cards_sales: {
      label: 'Geschenkgutscheine Umsatz',
    },
    average_order_value: {
      label: 'Durchschnittlicher Bestellwert',
    },
    savings: {
      label: 'Ersparnisse bei Drittanbieter-Gebühren',
    },
    reservations: {
      label: 'Reservierungen',
    },
    sales_from_email: {
      label: 'Umsatz durch E-Mail',
    },
    sales_from_google_seo: {
      label: 'Umsatz durch Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Umsatz durch Google Business',
    },
    sales_from_google_ads: {
      label: 'Umsatz durch Google Ads',
    },
    sales_from_flyers: {
      label: 'Umsatz durch Flyer',
    },
    sales_from_social_media: {
      label: 'Umsatz durch Social Media',
    },
    sales_from_facebook_ads: {
      label: 'Umsatz durch Facebook Ads',
    },
    tips: {
      label: 'Trinkgeld',
    },
    new_customers: {
      label: 'Neue Kunden',
    },
    returning_customers: {
      label: 'Wiederkehrende Kunden',
    },
    new_visitors: {
      label: 'Neue Besucher',
    },
    new_followers: {
      label: 'Neue Follower',
    },
    total_followers: {
      label: 'Gesamtanzahl Follower',
    },
    delivered_messages: {
      label: 'Zugestellte Nachrichten',
    },
    average_open_rate: {
      label: 'Durchschnittliche E-Mail-Öffnungsrate',
    },
    average_click_rate: {
      label: 'Durchschnittliche Klickrate',
    },
    website_visitors_from_email: {
      label: 'Website-Besucher durch E-Mail',
    },
    sales_from_google_business: {
      label: 'Umsatz durch Google Business',
    },
    total_reservations: {
      label: 'Reservierungen',
    },
    website_visitors_from_google_seo: {
      label: 'Website-Klicks durch Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Website-Klicks durch Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Website-Klicks durch Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Website-Klicks durch Social Media',
    },
    calls_from_google_ads: {
      label: 'Anrufe durch Google Ads',
    },
    directions_from_google_ads: {
      label: 'Wegbeschreibungen durch Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Social Media',
    },
    flyer_orders_count: {
      label: 'Flyer',
    },
    email_orders_count: {
      label: 'E-Mails',
    },
    other_orders_count: {
      label: 'Andere',
    },
    gmv: {
      label: 'Bruttowarenwert (GMV)',
    },
    gift_cards_gmv: {
      label: 'Gutschein',
    },
    net_billed_revenue: {
      label: 'In Rechnung gestellter Umsatz (NETTO)',
    },
    net_billed_revenue_subscription: {
      label: 'In Rechnung gestellte Abonnementumsätze',
    },
    net_billed_revenue_service_fee: {
      label: 'In Rechnung gestellte Servicegebühren',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'In Rechnung gestellte Liefergebühren',
    },
    net_billed_revenue_other: {
      label: 'In Rechnung gestellte Servicegebühren',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'In Rechnung gestellte Lieferkosten – Weiterberechnung',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'In Rechnung gestellte Plattform-Bearbeitungsgebühren',
    },
    gross_cash_income: {
      label: 'Bareinnahmen (brutto)',
    },
    gross_cash_income_subscription: {
      label: 'Bareinnahmen aus Abonnements',
    },
    gross_cash_income_service_fee: {
      label: 'Bareinnahmen aus Dienstleistungsgebühren',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Bareinnahmen aus Liefergebühren',
    },
    gross_cash_income_other: {
      label: 'Bareinnahmen aus Servicegebühren',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Bareinnahmen aus Durchleitungsgebühren für Lieferungen',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Bareinnahmen aus Plattform-Bearbeitungsgebühren',
    },
    net_cash_income: {
      label: 'Bareinnahmen (NETTO)',
    },
    net_cash_income_subscription: {
      label: 'Bareinnahmen aus Abonnements',
    },
    net_cash_income_service_fee: {
      label: 'Bareinnahmen aus Servicegebühren',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Bareinnahmen aus Liefergebühren',
    },
    net_cash_income_other: {
      label: 'Bareinnahmen aus Servicegebühren',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Bareinnahmen aus Lieferweiterberechnungsgebühren',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Bareinnahmen aus Plattform-Bearbeitungsgebühren',
    },
    manual_connect_transfers: {
      label: 'Rückerstattung an Restaurants',
    },
    processing_fees: {
      label: 'Bearbeitungsgebühren',
    },
    processing_fees_stripe: {
      label: 'Bearbeitungsgebühren (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Bearbeitungsgebühren (PayPal)',
    },
    platform_processing_fees: {
      label: 'Plattform-Bearbeitungsgebühren',
    },
    rejected_orders: {
      label: 'Abgelehnte Bestellungen',
    },
    rejected_orders_amount: {
      label: 'Betrag abgelehnter Bestellungen',
    },
    rejected_orders_count: {
      label: 'Anzahl abgelehnter Bestellungen',
    },
    rejected_orders_rate: {
      label: 'Ablehnungsrate der Bestellungen',
    },
    rejected_orders_rate_breakdown: {
      label: 'Aufschlüsselung der Ablehnungsrate',
    },
    orders: {
      label: 'Bestellungen',
    },
    total_orders: {
      label: 'Gesamtanzahl Bestellungen',
    },
    pickup_orders_rate: {
      label: 'Abholrate der Bestellungen',
    },
    delivery_orders_rate: {
      label: 'Lieferungsrate der Bestellungen',
    },
    other_orders_rate: {
      label: 'Sonstige Bestellrate',
    },
    customers: {
      label: 'Gesamtanzahl Kunden',
    },
    customers_auth_state: {
      label: 'Authentifizierungsstatus der Kunden',
    },
    website_reservations: {
      label: 'Reservierungen über die Website',
    },
    google_reservations: {
      label: 'Reservierungen über Google',
    },
    companies: {
      label: 'Unternehmen',
    },
    live_companies: {
      label: 'Live-Restaurants',
    },
    live_companies_percentage: {
      label: 'Prozentualer Anteil der Live-Restaurants',
    },
    setup_packages_breakdown: {
      label: 'Pakete einrichten',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Pakete nach Rechnungsquelle einrichten',
    },
    crossed_sales_level_this_month: {
      label: 'Überschrittenes Verkaufsniveau diesen Monat',
    },
    crossed_sales_level_total: {
      label: 'Gesamtanzahl überschrittener Verkaufsniveaus',
    },
    crossed_sales_level_percentage: {
      label: 'Prozentualer Anteil überschrittener Verkaufsniveaus',
    },
    has_delivery: {
      label: 'Eigene Lieferung',
    },
    has_only_pickup: {
      label: 'Nur Abholung',
    },
    has_storefront: {
      label: 'Hat Schaufenster',
    },
    has_storefront_percentage: {
      label: 'Prozentualer Anteil der Schaufenster',
    },
    use_external_delivery: {
      label: 'Externe Lieferung',
    },
    crossed_sales: {
      label: 'Über {{value}} Umsatz',
    },
    restaurant_partners: {
      label: 'Restaurant-Partner',
    },
    registered_restaurants: {
      label: 'Registrierte Restaurants',
    },
    signed_restaurants: {
      label: 'Unterzeichnete Partner',
    },
    use_reservations: {
      label: 'Nutzt Reservierungen',
    },
    number: {
      label: 'Nummer',
    },
    restaurants_percentage: {
      label: 'Prozentualer Anteil der Restaurants',
    },
    crossed_sales_level: {
      label: 'Überschrittenes Verkaufsniveau',
    },
    order_method: {
      label: 'Bestellmethode',
    },
    own_delivery: {
      label: 'Eigene Lieferung',
    },
    only_pickup: {
      label: 'Nur Abholung',
    },
    storefront: {
      label: 'Website',
    },
    sales_tiers: {
      label: 'Verkaufsstufen',
    },
    new_pricing_adoption_rate: {
      label: 'Neue Preisgestaltung Akzeptanzrate',
    },
    mobile_app_attach_rate: {
      label: 'Anschlussrate für mobile Apps',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Gebühren für die Einrichtung der mobilen App ausgewählt',
    },
    first_delivery: {
      label: 'Uber (First Delivery)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Anzahl der Lieferangebote',
    },
    deliveries_count: {
      label: 'Anzahl der Lieferungen',
    },
    delivery_conversion: {
      label: 'Lieferkonversionsrate',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Aufschlüsselung der Lieferangebote nach Anbieter',
    },
    deliveries_provider_breakdown: {
      label: 'Aufschlüsselung der Lieferungen nach Anbieter',
    },
    delivery_distance_breakdown: {
      label: 'Aufschlüsselung der Lieferentfernungen',
    },
    total_delivered: {
      label: 'Zugestellte Nachrichten',
    },
    website_visitors_from_google_business_profile: {
      label: 'Website Clicks von Google Business',
    },
    google_business_impressions: {
      label: 'Impressionen von Google Business',
    },
    google_business_website_clicks: {
      label: 'Website-Klicks von Google Business',
    },
    google_ads_impressions: {
      label: 'Impressionen Google Ads',
    },
    google_ads_clicks: {
      label: 'Klicks Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Anrufe Google Ads',
    },
    google_ads_directions: {
      label: 'Wegbeschreibungen Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Durchschnittlicher Absolute Top-Impression-Prozent Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Durchschnittliche Kosten pro Klick Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Durchschnittliche Konversionsrate aus Interaktionen Google Ads',
    },
    website_visits: {
      label: 'Website-Besuche',
    },
    website_visitors: {
      label: 'Website-Besucher',
    },
    companies_with_activated_reservations: {
      label: 'Restaurants mit aktivierten Reservierungen',
    },
    online_orders_count: {
      label: 'Online-Bestellungen',
    },
    cash_orders_count: {
      label: 'Bargeldbestellungen',
    },
    cash_sales: {
      label: 'Barverkäufe',
    },
    online_sales: {
      label: 'Online-Verkäufe',
    },
    payouts: {
      label: 'Auszahlungen',
    },
    last_payout_amount: {
      label: 'Letzte Auszahlung',
    },
    pending_payout_amount: {
      label: 'Im Transit',
    },
    future_payout_amount: {
      label: 'Verfügbar zukünftige Auszahlungen',
    },
    mobile_app_average_order_value: {
      label: 'Durchschnittlicher Bestellwert über App',
    },
    mobile_app_gmv: {
      label: 'Gesamtumsatz über App',
    },
    mobile_app_gmv_percentage: {
      label: 'Umsatzanteil aus App (%)',
    },
    mobile_app_downloads: {
      label: 'Gesamtzahl App-Downloads',
    },
    mobile_app_orders_count: {
      label: 'Gesamtzahl Bestellungen über App',
    },
    net_billed_revenue_gift_cards: {
      label: 'Abgerechneter Umsatz aus Geschenkkarten',
    },
    gross_cash_income_gift_cards: {
      label: 'Brutto-Geldeingang aus Geschenkkarten',
    },
    net_cash_income_gift_cards: {
      label: 'Netto-Geldeingang aus Geschenkkarten',
    },
  },
};
